export default "__VITE_ASSET__DtXvwuyr__"